"use client";
import { jsx as e, jsxs as d } from "react/jsx-runtime";
import { s as i } from "../../Author.module-DO0Qr1K7.mjs";
import { CompanyLink as a } from "./CompanyLink.es.js";
const f = ({ title: n, company: s, url: r, isCompanyProfile: t = !1 }) => t && r ? /* @__PURE__ */ e("div", { className: i.authorMeta, children: /* @__PURE__ */ e(a, { company: s ?? r, url: r, testId: "company-profile-link" }) }) : (n || s) && !t ? /* @__PURE__ */ d("div", { className: i.authorMeta, children: [
  n && /* @__PURE__ */ e("span", { children: n }),
  n && s && /* @__PURE__ */ e("span", { children: ", " }),
  s && (r ? /* @__PURE__ */ e(a, { company: s, url: r, testId: "company-link" }) : /* @__PURE__ */ e("span", { children: s }))
] }) : null;
export {
  f as AuthorMeta
};
//# sourceMappingURL=AuthorMeta.es.js.map
